import { showNotification } from "@mantine/notifications";
import { Navigate } from "react-router";
import { Refresh } from "tabler-icons-react";
import { axiosPost, userData } from "../../Helpers";
import routeNames from "../../routes/routeNames";

export const followFunction = async (
  followId,
  setLoading,
  refresh,
  setRefresh
) => {
  setLoading(true);
  let apiResponse = await axiosPost("user/followUser", {
    followerId: userData?.id,
    followingId: followId,
  });
  setLoading(false);
  if (apiResponse.data.status) {
    setRefresh(!refresh);
    showNotification({
      title: "Followed",
      message: "You have followed this user",
      color: "green",
    });
  } else {
    setRefresh(!refresh);
    showNotification({
      title: "Error",
      message: "Something went wrong",
      color: "red",
    });
  }
  return apiResponse.data.data;
};
export const unfollowFunction = async (
  followId,
  setLoading,
  refresh,
  setRefresh
) => {
  setLoading(true);
  let apiResponse = await axiosPost("user/unfollowUser", {
    followerId: userData?.id,
    followingId: followId,
  });
  console.log(apiResponse, "apiResponse");
  setLoading(false);
  if (apiResponse.data.status) {
    showNotification({
      title: "Unfollowed",
      message: "You have unfollowed this user",
      color: "green",
    });
    setRefresh(!refresh);
  } else {
    showNotification({
      title: "Error",
      message: "Something went wrong",
      color: "red",
    });
    setRefresh(!refresh);
  }
  return apiResponse.data.data;
};

export const initiateChatWithUser = async (userId, message) => {
  let apiResponse = await axiosPost("chat/sendMessage", {
    fromUserId: userData.id,
    toUserId: userId,
    message: message || "",
  });
  console.log(apiResponse, "apiResponse");
  if (apiResponse.data.status) {
    <Navigate to={routeNames.jobSeeker.messages} />;
  } else {
    console.log("error");
  }
};
